import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    Grid,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select
} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const data = [
    {value: 1, label: "Purchasing"},
    {value: 2, label: "Information"},
]


const RFQType = ({value, setValue, hasAll = true, error, isDisabled}) => {
    const isAll = hasAll && value?.includes(-1)
    const [checked, setChecked] = useState(isAll);
    const [disabled, setDisabled] = useState(isAll);

    const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked);

    useEffect(() => {
        if (refreshClicked) {
            setChecked(isAll);
            setDisabled(isAll)
        }
    }, [refreshClicked])

    const handleCheckChange = (event) => {
        const isChecked = event.target.checked;
        setChecked(isChecked);
        setDisabled(isChecked);
        if (isChecked) {
            setValue([-1]);
        } else {
            setValue([]);
        }
    };

    const handleChange = (event) => {
        const selectedStatus = event.target.value;
        setValue(selectedStatus);
        setChecked(selectedStatus.includes(-1));
    };

    return (
        <>
            {hasAll ? (
                <Grid container spacing={1}>
                    <Grid item xs={9}>
                        <FormControl fullWidth size="small">
                            <InputLabel>RFQ Type</InputLabel>
                            <Select
                                multiple
                                disabled={disabled || isDisabled}
                                value={value || []}
                                onChange={handleChange}
                                input={<OutlinedInput label="RFQ Type"/>}
                                MenuProps={MenuProps}
                                style={{
                                    color: (disabled || isDisabled) && 'black !important',
                                    background: (disabled || isDisabled) && 'hsl(0, 0%, 95%)'
                                }}
                                renderValue={(selected) => {
                                    if (selected.includes(-1)) {
                                        return 'All';
                                    }
                                    return selected
                                        .map((x) => data.find((y) => y.value === x)?.label)
                                        .join(', ');
                                }}
                            >
                                {data.map((item) => (
                                    <MenuItem key={item.value} value={item.value}>
                                        <Checkbox checked={value?.includes(item.value)}/>
                                        <ListItemText primary={item.label}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={checked} onChange={handleCheckChange}/>
                                }
                                label="All"
                            />
                        </FormGroup>
                    </Grid>
                </Grid>
            ) : (
                <FormControl size="small" fullWidth>
                    <InputLabel>RFQ Type</InputLabel>
                    <Select
                        label="RFQ Type"
                        disabled={isDisabled}
                        error={Boolean(error)}
                        value={value || ''}
                        onChange={(event) => {
                            setValue(event.target.value);
                        }}
                        style={{
                            color: isDisabled && 'black !important',
                            background: isDisabled && 'hsl(0, 0%, 95%)'
                        }}
                    >
                        <MenuItem value={''}>
                            None
                        </MenuItem>
                        {data.map(item => (
                            <MenuItem key={item.value} value={item.value}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && (
                        <FormHelperText
                            sx={{color: '#d32f2f', ml: 0}}>{error.message || 'This field is required'}</FormHelperText>
                    )}
                </FormControl>
            )}
        </>
    )
};

export default RFQType;
